import { connect } from '@vfde-sails/core';
import {
    State,
    mapStateToProps,
} from '../App/selector';
import * as mapDispatch from '../App/action';
import { getUpdateFlags } from './update';
import { mountOptionPicker } from '../../components/optionPicker';
import { TariffCardId } from '../../enums/elementId';
import { mountVerticalList } from '../../components/unorderedVerticalList';
import { getTariffBenefitsUpdatedProps } from '../../util/components/verticalList.util';

type Actions = typeof mapDispatch;

function container (state: State, actions: Actions) {
    const tariffPicker = mountOptionPicker(TariffCardId.TariffPicker, (value: string) => actions.setSelectedTariffId(value));
    const tariffBenefits = mountVerticalList(TariffCardId.TariffBenefits);

    return {
        getDerivedStateFromProps (newState: State, oldState: State) {
            const { selectedTariff } = newState;
            const update = getUpdateFlags(newState, oldState);

            if (update.selected && selectedTariff) {
                tariffPicker?.setValue(selectedTariff.id);
                tariffBenefits?.update(getTariffBenefitsUpdatedProps(tariffBenefits, selectedTariff));
            }
        },
    };
}

export default connect(mapStateToProps, mapDispatch)(container);
